import { ReactiveController, ReactiveControllerHost } from 'lit';
import { ErrorResponse, OrderDto } from '../../interfaces/index.js';
import { StatusRenderer, Task } from '@lit/task';
import { fetchOrder } from '../../order-api.js';
import { OrderLoadedEvent } from '../../events.js';

export class OrderRequestController implements ReactiveController {
  orderCode = '';
  task: Task<[string], OrderDto>;
  order?: OrderDto;
  errorType: 'no-code' | 'not-found' | 'network' | null = null;

  constructor(host: ReactiveControllerHost, orderCode: string) {
    this.orderCode = orderCode;
    host.addController(this);

    this.task = new Task(host, {
      task: async (
        [orderCode]: readonly [string],
        { signal }: { signal: AbortSignal }
      ) => {
        try {
          const order = await fetchOrder(orderCode, signal);
          window.dispatchEvent(new OrderLoadedEvent(order));
          this.order = order;
          return order;
        } catch (error: unknown) {
          const { code } = error as ErrorResponse;
          this.errorType = code === 'ORDER_NOT_FOUND' ? 'not-found' : 'network';

          host.requestUpdate();
          throw error;
        }
      },
      args: () => [this.orderCode] as const,
    });
  }

  render(renderFunctions: StatusRenderer<OrderDto>) {
    return this.task.render(renderFunctions);
  }

  hostDisconnected() {
    this.task.abort();
  }
}
